import type { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { experimentalStyled } from '@material-ui/core/styles';
import FaqNavBar from './FaqNavbar';
import Footer from '../Footer';

const FaqLayoutRoot = experimentalStyled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  height: '100%',
}));

const FaqLayout: FC = () => (
  <FaqLayoutRoot>
    <FaqNavBar />
    <Outlet />
    <Footer />
  </FaqLayoutRoot>
);

export default FaqLayout;
